import { loadStripe } from "@stripe/stripe-js";

const WEBSITE = process.env.REACT_APP_WEBSITE;
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "pk_test_key");
const captchaSiteKey = process.env.REACT_APP_CAPTCHA_SITE_KEY;
const discordLink = process.env.REACT_APP_DISCORD_LINK;
const g2gLink = process.env.REACT_APP_G2G_LINK;

export { WEBSITE, stripePromise, captchaSiteKey, discordLink, g2gLink };
